import "./AllFiles.scss";
import newRequest from "../../utils/newRequest.js";
import ConfirmDialog from "../confirmDialog/confirmDialog";
import axios from "axios";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { BiSolidFileTxt, BiSolidFileJpg, BiSolidFilePng } from "react-icons/bi";
import { BsFiletypeMp4 } from "react-icons/bs";
import { FaFileWord } from "react-icons/fa";
import { FaFilePdf } from "react-icons/fa6";
import { RiFileExcel2Fill } from "react-icons/ri";
import { PiFileCsvFill, PiFilePptFill } from "react-icons/pi";
import { MdEdit, MdOutlineCheck, MdClose, MdDelete, MdFileDownload, MdFolderZip } from "react-icons/md";
import { HiViewfinderCircle } from "react-icons/hi2";
import { IoMdShare } from "react-icons/io";
import { useSelector } from "react-redux";
import { GridLoader, ScaleLoader } from "react-spinners";
import Select from "react-select";
import { customSelectStyles_dark, customSelectStyles_light } from "../../components/ui/CustomSelect.jsx";
import CircularButton, { CustomLoadingButton } from "../ui/CustomButton.jsx";
import PdfPreview from "../pdfPreview/PdfPreview.jsx";
import { useTranslation } from "react-i18next";
import { sanitizeText, isValidMobileNumber, logData } from "../../utils/genericFunctions.js";
import {
  DialogActions,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import { showToast } from "../../toastService.js";
import { ImWhatsapp } from "react-icons/im";

const AllFiles = ({ filesList, bgColor, allowPreview = "Y", allowDownload = "Y", allowDelete = "Y", allowEdit = "Y", whatsappAllowed = "N", phoneNo = null }) => {
  // console.log(`filesList  ${JSON.stringify(filesList, null, 2)}`);
  const { t } = useTranslation();

  const { currentTheme } = useSelector((state) => state.theme);
  const { currentUser } = useSelector((state) => state.user);
  const [isProcessing, setIsProcessing] = useState(false);
  const [isProcessingTitle, setIsProcessingTitle] = useState(t('pleaseWait'));
  const [objectToAction, setObjectToAction] = useState({
    object_id: "",
    action_text: "",
    file_path: "",
  });
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [pdfPreviewDialogOpen, setPdfPreviewDialogOpen] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [fileType, setFileType] = useState(null);
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
  const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
  const [notifyDialogText, setNotifyDialogText] = useState("Text");
  const [confirmDialogAction, setConfirmDialogAction] = useState("None");
  const [selectedFile, setSelectedFile] = useState(null);
  const [filteredFileList, setFilteredFileList] = useState(null);
  const [docFlag, setDocFlag] = useState(null);
  const [docFlagOptions, setDocFlagOptions] = useState([]);
  const [editCategoryMap, setEditCategoryMap] = useState({});
  const [whatsAppDialogOpen, setWhatsAppDialogOpen] = useState(false);
  const [to, setTo] = useState(phoneNo || "");
  const [caption, setCaption] = useState("");
  const [charCount, setCharCount] = useState(0);
  const [viewMode, setViewMode] = useState("GRID"); // GRID | PREVIEW


  const fetchDocumentFlags = async () => {
    try {
      const res = await newRequest.post(
        "/sysCode/findAll", { sys_type: "File Flag" }
      );
      const options = res.data.map((row) => ({
        value: row?.sys_code,
        label: row?.sys_name,
      }));
      setDocFlagOptions(options);
    } catch (error) {
      console.error("Error fetching entity types:", error);
    }
  };


  const handleContentChange = (e) => {
    const value = e.target.value;
    setCaption(value);
    setCharCount(value.length);
  };

  // Returns the best URL to use in <img src>, <video src>, window.open, etc.
  // - firebase: fl_path is already a full URL
  // - backend : use protected endpoint
  const getFileUrl = (f) => {
    if (!f) return "";
    return ["backend", "chatbot"].includes(String(f?.fl_source || "").toLowerCase()) ? `/uploadFiles/download/${f?._id}?inline=1` : (f?.fl_path || "");
  };

  // Fetches blob for both firebase and backend (uses auth headers via newRequest for backend)
  const fetchFileBlobUrl = async (f) => {
    if (!f) return "";
    const url = getFileUrl(f);
    logData("url", url);
    // IMPORTANT:
    // - For backend protected endpoint, MUST use newRequest so token/cookies are included.
    // - For firebase public URL, newRequest also works if CORS is OK; otherwise fallback to axios.
    try {
      const res = await newRequest.get(url, { responseType: "blob" });
      // logData("from backend ", res.data);
      return URL.createObjectURL(res.data);
    } catch (e) {
      // fallback (firebase/public)
      const res2 = await axios.get(url, { responseType: "blob" });
      return URL.createObjectURL(res2.data);
    }
  };

  const handlePdfPreview = async (fileObj) => {
    setPdfPreviewDialogOpen(true);
    setIsPreviewLoading(true);
    setPdfUrl(null);

    try {
      const blobUrl = await fetchFileBlobUrl(fileObj);
      setPdfUrl(blobUrl);
      setFileType(fileObj?.fl_type);
    } catch (e) {
      showToast("Unable to preview file", "error");
      setPdfPreviewDialogOpen(false);
    } finally {
      setIsPreviewLoading(false);
    }
  };


  const getDownloadFileName = (f) => {
    const rawName = (f?.fl_name || "file").trim();
    const ext = (f?.fl_type || "").trim().replace(/^\./, "");

    // already has an extension
    if (/\.[a-zA-Z0-9]+$/.test(rawName)) {
      return rawName;
    }

    return ext ? `${rawName}.${ext}` : rawName;
  };

  const downloadFile = async (f) => {
    try {
      if (!f) return;
      setIsProcessing(true);

      const blobUrl = await fetchFileBlobUrl(f);
      const fileName = getDownloadFileName(f);

      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      a.remove();

      setTimeout(() => URL.revokeObjectURL(blobUrl), 1500);
    } catch (err) {
      console.log(err);
      showToast("Unable to download file", "error");
    } finally {
      setIsProcessing(false);
    }
  };

  const handleConfirm = async () => {
    try {
      if (confirmDialogAction === "deleteFile") {
        setIsConfirmDialogOpen(false);
        setIsProcessing(true);
        // delete file from db
        // this function will also delete from firebase
        const res = await newRequest.delete(`/files/del/${objectToAction.object_id}`);
        const filteredArray = filteredFileList.filter(
          (obj) => obj._id !== objectToAction.object_id
        );
        setFilteredFileList(filteredArray);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsProcessing(false);
      // Close the dialog
      setIsConfirmDialogOpen(false);
    }
  };


  const handleDocumentShare = async () => {
    try {

      if (!to) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please specify valid WhatsApp Number!`);
        setIsNotifyDialogOpen(true);
        return false;
      } else {
        if (!isValidMobileNumber(to)) {
          setNotifyDialogTitle("Note!");
          setNotifyDialogText(`Please specify valid WhatsApp Number!`);
          setIsNotifyDialogOpen(true);
          return false;
        }
      }

      if (!caption) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please enter caption!`);
        setIsNotifyDialogOpen(true);
        return false;
      }

      setIsProcessing(true);
      let docType = null;

      if (["jpg", "jpeg", "png", "gif", "webp"].includes(selectedFile?.fl_type)) {
        docType = "image";
      } else if (["mp4"].includes(selectedFile?.fl_type)) {
        docType = "video";
      } else if (["pdf", "doc", "docx", "xlsx", "xls"].includes(selectedFile?.fl_type)) {
        docType = "document";
      }

      if (!docType) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`This file type cannot be shared!`);
        setIsNotifyDialogOpen(true);
        return false;
      }

      const res = await newRequest.post("/exportFiles/sendFileToTwilio", {
        to,
        file_id: selectedFile?._id,
        message: caption,
      });

      setIsProcessing(false);
      // logData("res.data", res.data);
      if (res.data.msg === "sent") {
        setCaption("");
        setWhatsAppDialogOpen(false);
        showToast(`File shared with ${to}`, "success");
      } else {
        console.error("Error details:", res.data?.error);
        showToast("Error sharing the file!", "error");
      }

    } catch (error) {
      setIsProcessing(false);
      console.error("Error sharing document:", error);
    }
  };


  useEffect(() => {
    return () => {
      if (pdfUrl) URL.revokeObjectURL(pdfUrl);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pdfUrl]);

  useEffect(() => {
    setFilteredFileList(filesList);
  }, [filesList]);


  useEffect(() => {
    fetchDocumentFlags();
  }, []);

  const InlinePreview = ({ file }) => {
    const [src, setSrc] = useState("");
    const [failed, setFailed] = useState(false);

    useEffect(() => {
      let mounted = true;
      let blobToRevoke = "";

      const run = async () => {
        try {
          setFailed(false);
          // For firebase we can render directly for speed.
          if (file?.fl_source === "firebase") {
            if (mounted) setSrc(getFileUrl(file));
            return;
          }
          // For backend protected, fetch blob url
          const blobUrl = await fetchFileBlobUrl(file);
          blobToRevoke = blobUrl;
          if (mounted) setSrc(blobUrl);
        } catch (e) {
          if (mounted) setFailed(true);
        }
      };

      run();

      return () => {
        mounted = false;
        if (blobToRevoke) URL.revokeObjectURL(blobToRevoke);
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [file?._id]);

    if (failed || !src) {
      return (
        <div className="sf__previewPlaceholder">
          <span className="sf__previewHint">No inline preview</span>
          <span className="sf__previewSub">Use Preview or Download</span>
        </div>
      );
    }

    if (["jpg", "jpeg", "png", "gif", "webp"].includes(file?.fl_type)) {
      return <img className="sf__previewImg" src={src} alt="" onError={() => setFailed(true)} />;
    }

    if (file?.fl_type === "mp4") {
      return <video className="sf__previewVideo" src={src} controls preload="metadata" onError={() => setFailed(true)} />;
    }

    // if (file?.fl_type === "pdf") {
    //   // Use your PdfInlinePreview, but if it errors, fallback to placeholder
    //   return <PdfInlinePreview url={src} onError={() => setFailed(true)} />;
    // }
    if (file?.fl_type === "pdf") {
      return (
        <iframe
          className="sf__previewPdf"
          src={src}
          title={file?.fl_name}
          onError={() => setFailed(true)}
        />
      );
    }

    return (
      <div className="sf__previewPlaceholder">
        <span className="sf__previewHint">No inline preview</span>
        <span className="sf__previewSub">Use Preview or Download</span>
      </div>
    );
  };

  return (
    <div className="all-files">
      <div className="all-files-toolbar">
        <div className="aft-left" />
        {filesList?.length > 0 &&
          <div className="aft-right">
            <button
              type="button"
              // className={`set__auto ${autoTopup ? "is-on" : ""}`}
              className={`two-face-toggle is-on`}
              onClick={() => setViewMode((val) => val === "GRID" ? "PREVIEW" : "GRID")}
            >
              {viewMode === "GRID" ? "VIEW PREVIEW" : "VIEW GRID"}
            </button>
          </div>}
      </div>

      <div className={`all-files-wrapper ${viewMode === "PREVIEW" ? "preview" : "grid"}`}>
        {filteredFileList?.map((singleFile) => (
          <div
            className="single-file"
            style={{ backgroundColor: bgColor }}
            key={singleFile._id}
          >
            {/* HEADER */}
            <div className="sf__header">

              <div className="sf__file">
                <div className="sf__fileIcon">
                  {singleFile?.fl_type === "pdf" && <FaFilePdf className="pdf" />}
                  {["doc", "docx"].includes(singleFile?.fl_type) && <FaFileWord className="word" />}
                  {["xlsx", "xls"].includes(singleFile?.fl_type) && <RiFileExcel2Fill className="excel" />}
                  {singleFile?.fl_type === "csv" && <PiFileCsvFill className="excel" />}
                  {singleFile?.fl_type === "txt" && <BiSolidFileTxt className="txt" />}
                  {["jpg", "jpeg"].includes(singleFile?.fl_type) && <BiSolidFileJpg className="img" />}
                  {singleFile?.fl_type === "png" && <BiSolidFilePng className="img" />}
                  {singleFile?.fl_type === "mp4" && <BsFiletypeMp4 className="vid" />}
                  {["zip", "rar"].includes(singleFile?.fl_type) && <MdFolderZip className="zip" />}
                  {singleFile?.fl_type === "pptx" && <PiFilePptFill className="ppt" />}
                </div>

                <div className="sf__fileMeta">
                  <div className="sf__name" title={singleFile?.fl_name}>
                    {singleFile?.fl_name}
                  </div>
                </div>
              </div>

              {/* ACTIONS */}
              <div className="sf__actions">
                {["pdf", "jpg", "jpeg", "png", "gif", "webp"].includes(singleFile?.fl_type) &&
                  allowPreview === "Y" && (
                    <CircularButton
                      currentTheme={currentTheme}
                      onClick={() => handlePdfPreview(singleFile)}
                      icon={<HiViewfinderCircle color="teal" />}
                      width={"30px"}
                      height={"30px"}
                      color="#1DE9B6"
                      addBorder={false}
                    />
                  )}

                {allowDownload === "Y" && (
                  <CircularButton
                    currentTheme={currentTheme}
                    onClick={() => {
                      try {
                        setSelectedFile(singleFile);
                        downloadFile(singleFile);
                      } catch (error) {
                        console.log(error);
                      }
                    }}
                    icon={<MdFileDownload color="orange" />}
                    width={"30px"}
                    height={"30px"}
                    color="#00695C"
                    addBorder={false}
                  />
                )}

                {singleFile?.createdBy === currentUser?.usr_id && allowDelete === "Y" && (
                  <CircularButton
                    currentTheme={currentTheme}
                    onClick={(e) => {
                      try {
                        e.stopPropagation();
                        setSelectedFile(singleFile);
                        setObjectToAction({
                          object_id: singleFile._id,
                          action_text: `Delete ${singleFile?.fl_name}?`,
                          file_path: singleFile?.fl_path,
                        });
                        setConfirmDialogAction("deleteFile");
                        setIsConfirmDialogOpen(true);
                      } catch (error) {
                        console.log(error);
                      }
                    }}
                    icon={<MdDelete />}
                    width={"30px"}
                    height={"30px"}
                    color="#D84315"
                    addBorder={false}
                  />
                )}

                {["pdf", "mp4", "doc", "docx", "jpg", "jpeg", "png", "xlsx", "xls"].includes(singleFile?.fl_type) && (
                  <CircularButton
                    currentTheme={currentTheme}
                    onClick={() => {
                      try {
                        setSelectedFile(singleFile);
                        setWhatsAppDialogOpen(true);
                      } catch (error) {
                        console.log(error);
                      }
                    }}
                    icon={<IoMdShare />}
                    width={"30px"}
                    height={"30px"}
                    color="#5E35B1"
                    addBorder={false}
                  />
                )}
              </div>
            </div>
            {/* PREVIEW */}
            {viewMode === "PREVIEW" && (
              <div className="sf__preview">
                <InlinePreview file={singleFile} />
              </div>
            )}

            {/* BODY */}
            <div className="sf__body">
              <div className="sf__categoryLabel">{singleFile?.fl_category || "DOCUMENT"}</div>

              <div className="sf__flagRow">
                {!editCategoryMap[singleFile._id] && (
                  <div className="sf__flagText">{singleFile?.fl_flag || "UNCATEGORIZED"}</div>
                )}

                {editCategoryMap[singleFile._id] && (
                  <div className="sf__selectWrap">
                    <Select
                      id="new_doc"
                      name="new_doc"
                      value={docFlagOptions.find((opt) => opt.value === singleFile?.fl_flag)}
                      onChange={async (selectedOption) => {
                        try {
                          const updatedData = [...filteredFileList];
                          const rowIndex = updatedData.findIndex((item) => item._id === singleFile._id);

                          if (rowIndex !== -1) {
                            await newRequest.put(`/files/upd/${singleFile._id}`, {
                              fl_flag: selectedOption?.value,
                            });
                            updatedData[rowIndex].fl_flag = selectedOption?.value;
                            setFilteredFileList(updatedData);
                          }
                        } catch (error) {
                          console.log(error);
                        }
                      }}
                      options={docFlagOptions}
                      isSearchable={true}
                      placeholder={t("document")}
                      menuPortalTarget={document.body}
                      styles={{
                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                    />
                  </div>
                )}

                {!editCategoryMap[singleFile._id] && allowEdit === "Y" && (
                  <CircularButton
                    currentTheme={currentTheme}
                    onClick={() => setEditCategoryMap((prev) => ({ ...prev, [singleFile._id]: true }))}
                    icon={<MdEdit />}
                    width={"30px"}
                    height={"30px"}
                    color="#558B2F"
                    addBorder={false}
                  />
                )}

                {editCategoryMap[singleFile._id] && (
                  <CircularButton
                    currentTheme={currentTheme}
                    onClick={() => setEditCategoryMap((prev) => ({ ...prev, [singleFile._id]: false }))}
                    icon={<MdOutlineCheck />}
                    width={"30px"}
                    height={"30px"}
                    addBorder={false}
                  />
                )}
              </div>

              <div className="sf__divider" />

              {/* FOOTER */}
              <div className="sf__footer">
                <div className="sf__uploader">
                  <div className="sf__avatar">
                    {singleFile?.uploaded_by_photo_url_xx ? (
                      <img
                        src={singleFile?.uploaded_by_photo_url_xx}
                        alt=""
                      />
                    ) : (
                      <span className="sf__avatarText">
                        {(singleFile?.uploaded_by_name_xx || "U")
                          .split(" ")
                          .slice(0, 2)
                          .map((x) => x?.[0])
                          .join("")
                          .toUpperCase()}
                      </span>
                    )}
                  </div>

                  <div className="sf__uploaderMeta">
                    <div className="sf__uploaderLabel">{t('uploadedBy')?.toUpperCase()}</div>
                    <div className="sf__uploaderName">{singleFile?.uploaded_by_name_xx}</div>
                  </div>
                </div>

                <div className="sf__rightMeta">
                  <div className="sf__time">{singleFile?.time_ago_xx}</div>
                  <div className="sf__size">{singleFile?.file_size}</div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      {pdfPreviewDialogOpen && (
        <motion.div
          className="overlay-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper pdf">
            <div
              style={{
                display: "flex",
                borderRadius: "10px",
                boxShadow: "0 0 10px rgba(0, 0, 0, 0.3)",
                flexDirection: "row",
                gap: "5px",
                alignItems: "center",
                justifyContent: "space-between",
                margin: "0px 10px 0px 20px",
                padding: "5px 10px",
              }}
            >
              <div className="left">
                <span className="main-title">{t("preview")}</span>
              </div>
              <div className="right">
                <CircularButton currentTheme={currentTheme} onClick={() => setPdfPreviewDialogOpen(false)} icon={<MdClose />} width={"35px"} height={"35px"} />
              </div>
            </div>
            <div className="overlay-content-pdf">
              {isPreviewLoading ? (
                <div className="processing-wrapper">
                  <GridLoader color="#bd97fc" style={{ height: "50px", width: "50px" }} />
                </div>
              ) : (
                <PdfPreview pdfUrl={pdfUrl} fileType={fileType} />
              )}
            </div>
            <div className="overlay-actions"></div>
          </div>
        </motion.div>
      )}

      <ConfirmDialog
        isOpen={isConfirmDialogOpen}
        onClose={() => setIsConfirmDialogOpen(false)}
        onConfirm={handleConfirm}
        dialogTitle={t("confirmation")}
        dialogContent={<p>{objectToAction.action_text}</p>}
      />

      {isProcessing && (
        <motion.div
          className="processing-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="processing-wrapper">
            <span className='main-title'>{isProcessingTitle || t('pleaseWait')}</span>
            <ScaleLoader
              color="var(--primary)"
              height={50}
              radius={8}
              width={4}
            />
          </div>
        </motion.div>
      )}

      {whatsAppDialogOpen && (
        <motion.div
          className="overlay-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <div className="left">
                <span className="main-title">{t("shareToWhatsApp")}</span>
              </div>
              <div className="right">
                <CircularButton currentTheme={currentTheme} onClick={() => setWhatsAppDialogOpen(false)} icon={<MdClose />} width={"35px"} height={"35px"} />
              </div>
            </div>
            <div className="overlay-content">
              <div className="input-item-with-label">
                <input
                  id="to"
                  name="to"
                  type="text"
                  placeholder={t("to")}
                  value={to}
                  className="form-input-item"
                  style={{ width: "350px" }}
                  onChange={(e) => setTo(e.target.value)}
                />
              </div>
              <div className="input-item-with-label">
                <textarea
                  id="caption"
                  name="caption"
                  type="text"
                  placeholder={t("caption")}
                  value={caption}
                  rows={3}
                  className="form-input-item"
                  style={{ width: "350px" }}
                  onChange={handleContentChange}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleDocumentShare();
                    }
                  }}
                />
              </div>
            </div>
            <div className="overlay-actions">
              <span> {charCount} {t("characters")}  </span>
              <CustomLoadingButton
                currentTheme={currentTheme}
                onClick={handleDocumentShare}
                iconPosition="end"
                borderRadiusType="both"
                variant="tint"
                color="#E040FB"
                tooltip="Share on WhatsApp"
                endIcon={<ImWhatsapp />}
              >
                {t("share")}
              </CustomLoadingButton>
            </div>
          </div>
        </motion.div>
      )}

      <Dialog
        open={isNotifyDialogOpen}
        onClose={() => setIsNotifyDialogOpen(false)}
       PaperProps={{
          sx: {
            borderRadius: "16px",
            backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
            color: currentTheme === "dark" ? "#fff" : "#000",
          },
        }}
        slotProps={{
          backdrop: { sx: { backgroundColor: "rgba(0, 0, 0, 0.7)" } },
        }}
      >
        <DialogTitle>{notifyDialogTitle}</DialogTitle>
        <DialogContent>
          <div dangerouslySetInnerHTML={{ __html: sanitizeText(notifyDialogText) }} />
        </DialogContent>
        <DialogActions>
          <CustomLoadingButton currentTheme={currentTheme} variant="tint" color="#E040FB" onClick={() => setIsNotifyDialogOpen(false)}>{t('close')}</CustomLoadingButton>
        </DialogActions>
      </Dialog>
    </div>
  );

};


export default AllFiles;
